import script from "./MdHighlightText.vue?vue&type=script&lang=js"
export * from "./MdHighlightText.vue?vue&type=script&lang=js"

import "./MdHighlightText.vue?vue&type=style&index=0&id=4b07cc6c&lang=scss"

const __exports__ = script;

export default __exports__